// extracted by mini-css-extract-plugin
export default {"container":"ApprovalStatus_container__AaxNU","containerDarkMode":"ApprovalStatus_containerDarkMode__abop9","iconContainer":"ApprovalStatus_iconContainer__tkD6l"};